var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.174 5.257c-1.327 0-2.503 1.185-2.503 2.776 0 1.591 1.176 2.776 2.503 2.776 1.327 0 2.503-1.185 2.503-2.776 0-1.591-1.176-2.776-2.503-2.776ZM5.17 8.033c0-2.304 1.736-4.276 4.003-4.276 2.267 0 4.003 1.972 4.003 4.276s-1.736 4.276-4.003 4.276c-2.267 0-4.003-1.972-4.003-4.276ZM3.25 17.73c0-.905.322-1.585.802-2.04.485-.462 1.177-.736 1.981-.736h6.282c.805 0 1.496.274 1.982.735.48.456.801 1.136.801 2.041v1.013H3.25V17.73Zm2.783-4.276c-1.146 0-2.221.394-3.015 1.148-.799.76-1.268 1.843-1.268 3.128v1.322c0 .29.102.583.305.811.206.231.505.38.838.38h12.563c.333 0 .632-.149.837-.38a1.22 1.22 0 0 0 .305-.81V17.73c0-1.285-.469-2.369-1.268-3.128-.793-.754-1.868-1.148-3.015-1.148H6.033Zm11.527.036a.75.75 0 0 0 0 1.5c1.752 0 3.19 1.098 3.19 2.74v1.013h-2.49a.75.75 0 1 0 0 1.5h2.848c.333 0 .632-.15.838-.38a1.22 1.22 0 0 0 .304-.81V17.73c0-2.74-2.407-4.24-4.69-4.24Zm-1.824-4.317c0-.98.698-1.636 1.397-1.636.7 0 1.397.656 1.397 1.636 0 .98-.698 1.636-1.397 1.636-.699 0-1.397-.656-1.397-1.636Zm1.397-3.136c-1.672 0-2.897 1.48-2.897 3.136 0 1.656 1.225 3.136 2.897 3.136 1.673 0 2.897-1.48 2.897-3.136 0-1.655-1.224-3.136-2.897-3.136Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/人员管理.115e605cabbca7344d0ac3099b733421.svg";
export { ForwardRef as ReactComponent };